<template>
  <div class="cookie-modal-main cookie-modal-main-settings">
    <div class="cookie-modal-main-content">
      <div class="cookie-modal-container">
        <div class="col-12 cookie-modal-header">
          <span>{{ t('cookies.settings') }}</span>
          <p>{{ t('cookies.settings.main', {params: [{shopname: eshopName}]}) }}</p>
        </div>
        <div class="col-12 cookie-check-row">
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="functionalityStorage"
                type="checkbox"
                class="cookie_switch"
                id="CookiesRequiredCheckbox"
                disabled
              >
              <label
                for="CookiesRequiredCheckbox"
              ><strong>{{ t('cookies.settings.cookies_required') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.functionality') }}</p>
          </div>
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="analyticsStorage"
                type="checkbox"
                class="cookie_switch"
                id="CookiesAnalyticsCheckbox"
              >
              <label
                for="CookiesAnalyticsCheckbox"
              ><strong>{{ t('cookies.settings.cookies_analytics') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.analytics') }}</p>
          </div>
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="adStorage"
                type="checkbox"
                class="cookie_switch"
                id="CookiesAdvertisingCheckbox"
              >
              <label
                for="CookiesAdvertisingCheckbox"
              ><strong>{{ t('cookies.settings.cookies_advertising') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.advertising', {params: [{shopname: eshopName}]}) }}</p>
          </div>
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="personalizationStorage"
                type="checkbox"
                class="cookie_switch"
                id="CookiesPersonalizationCheckbox"
              >
              <label
                for="CookiesPersonalizationCheckbox"
              ><strong>{{ t('cookies.settings.cookies_personalization') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.personalization') }}</p>
          </div>
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="adUserData"
                type="checkbox"
                class="cookie_switch"
                id="CookiesAdUserDataCheckbox"
              >
              <label
                for="CookiesAdUserDataCheckbox"
              ><strong>{{ t('cookies.settings.cookies_ad_user_data') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.ad_user_data') }}</p>
          </div>
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="adPersonalization"
                type="checkbox"
                class="cookie_switch"
                id="CookiesAdPersonalizationCheckbox"
              >
              <label
                for="CookiesAdPersonalizationCheckbox"
              ><strong>{{ t('cookies.settings.cookies_ad_personalization') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.ad_personalization') }}</p>
          </div>
        </div>
        <div class="col-12 cookie-modal-header">
          <p v-if="cookiePagesToShow && cookiePagesToShow.length > 0" v-html="t(
                'cookies.settings.more.v2',
                { params: [{ shopname: eshopName}] }) + formattedCookiePages"></p>
          <p v-else v-html="t(
                'cookies.settings.more',
                { params: [{ shopname: eshopName, policyurl: basePolicyUrl }] })"
          ></p>
        </div>
        <div class="col-12 cookie-modal-actions-row">
          <div class="row row-mlr-0">
            <div class="col-12 cookie-modal-action-col">
              <button class="cookie-modal-btn cookie-modal-btn-partial" data-action="consentToCookiesPartial" @click="postCookieSettingsPartial">
                <span>{{ t('cookies.settings.consent.partial') }}</span>
              </button>
              <button class="cookie-modal-btn cookie-modal-btn-all" data-action="consentToCookies" @click="postCookieSettingsAllGrantedAction">
                <span>{{ t('cookies.settings.consent') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  ConsentOptionsEnum,
  ConsentStorageEnum,
  CookieConsentNamesEnum
} from '../../../../vue/cookies/store/cookiesModule'
import { setCookie } from '../../../js/es6/utilities/cookie-access'

export default {
  name: 'CookieSettings',
  computed: {
    ...mapGetters([
      'config',
    ]),
    ...mapGetters('cookies', [
      'getAdStorage',
      'getAnalyticsStorage',
      'getFunctionalityStorage',
      'getPersonalizationStorage',
      'getAdUserData',
      'getAdPersonalization'
    ]),
    ConsentStorage: {
      get () {
        return ConsentStorageEnum
      }
    },
    adStorage: {
      get () {
        return this.getAdStorageState === ConsentStorageEnum.GRANTED
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_AD_STORAGE,
          consentValue: value ? ConsentStorageEnum.GRANTED : ConsentStorageEnum.DENIED
        })
      }
    },
    analyticsStorage: {
      get () {
        return this.getAnalyticsStorageState === ConsentStorageEnum.GRANTED
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_ANALYTICS_STORAGE,
          consentValue: value ? ConsentStorageEnum.GRANTED : ConsentStorageEnum.DENIED
        })
      }
    },
    functionalityStorage: {
      get () {
        return this.getFunctionalityStorageState === ConsentStorageEnum.GRANTED
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_FUNCTIONALITY_STORAGE,
          consentValue: value ? ConsentStorageEnum.GRANTED : ConsentStorageEnum.DENIED
        })
      }
    },
    personalizationStorage: {
      get () {
        return this.getPersonalizationStorageState === ConsentStorageEnum.GRANTED
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_PERSONALIZATION_STORAGE,
          consentValue: value ? ConsentStorageEnum.GRANTED : ConsentStorageEnum.DENIED
        })
      }
    },
    adUserData: {
      get () {
        return this.getAdUserDataState === ConsentStorageEnum.GRANTED
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_AD_USER_DATA,
          consentValue: value ? ConsentStorageEnum.GRANTED : ConsentStorageEnum.DENIED
        })
      }
    },
    adPersonalization: {
      get () {
        return this.getAdPersonalizationState === ConsentStorageEnum.GRANTED
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_AD_PERSONALIZATION,
          consentValue: value ? ConsentStorageEnum.GRANTED : ConsentStorageEnum.DENIED
        })
      }
    },
    getAdStorageState () {
      return this.getAdStorage.value || this.getAdStorage.defaultValue
    },
    getFunctionalityStorageState () {
      return this.getFunctionalityStorage.value || this.getFunctionalityStorage.defaultValue
    },
    getAnalyticsStorageState () {
      return this.getAnalyticsStorage.value || this.getAnalyticsStorage.defaultValue
    },
    getPersonalizationStorageState () {
      return this.getPersonalizationStorage.value || this.getPersonalizationStorage.defaultValue
    },
    getAdUserDataState () {
      return this.getAdUserData.value || this.getAdUserData.defaultValue
    },
    getAdPersonalizationState () {
      return this.getAdPersonalization.value || this.getAdPersonalization.defaultValue
    },
    eshopName () {
      return this.t('hct.eshop.name')
    },
    basePolicyUrl() {
      const baseUrl = `${window.location.protocol}//${window.location.host}`
      return `${baseUrl}/${this.policyUrl}`
    },
    policyUrl () {
      return this.t('hct.eshop.policy.url')
    },
    cookiePagesToShow() {
      return this.config?.cookiePagesToShow
    },
    formattedCookiePages() {
      const baseUrl = `${window.location.protocol}//${window.location.host}`
      if (!this.cookiePagesToShow || this.cookiePagesToShow.length === 0) {
        return '';
      }
      return this.cookiePagesToShow
        .map(page => `<a href="${baseUrl}/category/${page.slug}" target="_blank">${page.name}</a>`)
        .join(', ');
    },
  },
  methods: {
    ...mapActions('cookies', [
      'setConsentValueByName',
      'setAllConsentValuesToGranted',
      'setConsentValuesFromState',
      'updateAllCookiesFromState',
      'updateGtagConsentFromState',
    ]),
    postCookieSettings () {
      setCookie(
        CookieConsentNamesEnum.CONSENT_STATUS,
        true,
        365
      ).then(() => {
        this.$root.$emit('cookies-modal-close')
      })
    },
    async postCookieSettingsAllGrantedAction () {
      await Promise.all([
        setCookie(
          CookieConsentNamesEnum.CONSENT_STATUS,
          true,
          365
        ),
        this.setAllConsentValuesToGranted(),
        this.updateAllCookiesFromState(),
        this.updateGtagConsentFromState(),
      ])
      this.$root.$emit('cookies-modal-close')
    },
    async postCookieSettingsPartial () {
      console.log('postCookieSettingsPartial')
      await Promise.all([
        setCookie(
          CookieConsentNamesEnum.CONSENT_STATUS,
          true,
          365
        ),
        this.setConsentValuesFromState(),
        this.updateAllCookiesFromState(),
        this.updateGtagConsentFromState(),
      ])
      this.$root.$emit('cookies-modal-close')
    }
  }
}
</script>
